// This file is generated by prom-i18n. Do not edit.
import { resolveSupportedLocale, unknownLocaleMessage } from '@talbenmoshe/prometheus-i18n-runtime';
export const SUPPORTED_LOCALES = ['en', 'he'];
const loaders = {
    'en': () => import('../locales/messages_en.json', { with: { type: 'json' } }),
    'he': () => import('../locales/messages_he.json', { with: { type: 'json' } })
};
export async function loadMessages(locale) {
    const resolved = resolveSupportedLocale(locale, SUPPORTED_LOCALES);
    if (resolved === undefined) {
        throw new Error(unknownLocaleMessage(locale, 'messages', SUPPORTED_LOCALES));
    }
    const loaded = await loaders[resolved]();
    return loaded.default;
}
//# sourceMappingURL=messages.loader.js.map